import React, { useState } from 'react';
import { Container,Row,Col, Form,FormGroup } from 'react-bootstrap'
import {toast} from 'react-toastify'
import { db,storage } from '../firebase.config'
import { ref,uploadBytesResumable,getDownloadURL } from 'firebase/storage'
import { collection,addDoc } from 'firebase/firestore' 
import { useNavigate } from 'react-router-dom';

const BoardAddProduct = () => {

    const [enterTitle,setEnterTitle] = useState('')
    const [enterShortDesc,setEnterShortDesc] = useState('')
    const [enterDescription,setEnterDescription] = useState('')
    const [enterPrice,setEnterPrice] = useState('')
    const [enterCategory,setEnterCategory] = useState('')
    const [enterProductImg,setEnterProductImg] = useState(null)
    const [loading,setLoading] = useState(false)

    const navigate = useNavigate()

    // function Add Proudct
    const addProduct = async (e) =>{
        e.preventDefault();
        setLoading(true)
        // 2
        try {
            const docRef = await collection(db, 'products');
            const storageRef = ref(storage, `productImages/${enterProductImg.name}`);
            const uploadTask = uploadBytesResumable(storageRef, enterProductImg, 'data_url');
            
            uploadTask.on('state_changed', null, null, async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                await addDoc(docRef, {
                title: enterTitle,
                shortDesc: enterShortDesc,
                description: enterDescription,
                price: enterPrice,
                category: enterCategory,
                imgUrl: downloadURL,
                });
            });
            setLoading(false)
            toast.success('Product added');
            navigate('/dashboard/all-products')
            } catch (error) {
            setLoading(false)
            toast.error('Product Not Added');
        }
}



    return (
        <section>
            <Container>
                <Row>
                    {
                        loading ? <Col lg='12'><h5 className='py-5 text-center'>Loading.....</h5></Col> : 
                        <Col lg='12'>
                            <h4 className='mb-5'>Add Product</h4>
                            <Form>
                                <FormGroup className='form__group'>
                                    <span>Product Title</span>
                                    <input required value={enterTitle} onChange={(e)=>setEnterTitle(e.target.value)} type="text" placeholder='Title' />
                                </FormGroup>

                                <FormGroup className='form__group'>
                                    <span>Short Description</span>
                                    <input required value={enterShortDesc} onChange={(e)=>setEnterShortDesc(e.target.value)} type="text" placeholder='Short description' />
                                </FormGroup>

                                <FormGroup className='form__group'>
                                    <span>Description</span>
                                    <input required value={enterDescription} onChange={(e)=>setEnterDescription(e.target.value)} type="text" placeholder='Description' />
                                </FormGroup>

                                <div className='d-flex align-items-center justify-content-between gap-5'>
                                    <FormGroup className='form__group w-50'>
                                        <span>Price</span>
                                        <input required value={enterPrice} onChange={(e)=>setEnterPrice(e.target.value)} type="number" placeholder='$20' />
                                    </FormGroup>

                                    <FormGroup className='form__group w-50'>
                                        <span>Category</span>
                                        <select value={enterCategory} onChange={(e)=>setEnterCategory(e.target.value)} className='w-100 p-2'>
                                            <option>Choose the Category</option>
                                            <option value="chair">Chair</option>
                                            <option value="sofa">Sofa</option>
                                            <option value="mobile">Mobile</option>
                                            <option value="watch">Watch</option>
                                            <option value="wireless">Wreless</option>
                                        </select>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup className='form__group'>
                                        <span>Product Iamge</span>
                                        <input required onChange={(e)=>setEnterProductImg(e.target.files[0])} type="file"  />
                                    </FormGroup>
                                </div>

                                <button onClick={addProduct} type='submit' className='buy__btn'>Add Product</button>

                            </Form>
                        </Col>
                    }
                </Row>
            </Container>
        </section>
    )
}

export default BoardAddProduct